import { createClasses } from "@bloomberg/media-ui-core";
import React from "react";
import styles from "./styles.module.css";
import { PortfolioFormHolding } from "~types/portfolio";

type HoldingRowProps = {
  onRemoveClick: () => void;
  holding: PortfolioFormHolding;
};

export default function HoldingRow(props: HoldingRowProps) {
  const { holding, onRemoveClick } = props;

  return (
    <>
      <div className={styles.row}>
        <div className={createClasses(styles.cell, styles.cellFixed)} />
        <div className={styles.cell}>
          <span className={styles.columnHeading}>Symbol</span>
        </div>
        <div className={styles.cell}>
          <span className={styles.columnHeading}>Total Shares</span>
        </div>
        <div className={styles.cell}>
          <span className={styles.columnHeading}>Cost Basis</span>
        </div>
      </div>

      <div
        className={createClasses(styles.row, styles.rowTop, styles.rowHolding)}
      >
        <div className={createClasses(styles.cell, styles.cellFixed)}>
          <button
            type="button"
            className={styles.removeHoldingButton}
            onClick={onRemoveClick}
            title="Remove holding"
            aria-label="Remove holding"
          >
            —
          </button>
        </div>
        <div className={styles.cell}>
          <div className={styles.holdingSymbol}>{props.holding.ticker}</div>
          <div className={styles.holdingCompany}>{holding.companyName}</div>
        </div>
        <div className={styles.cell}>
          <span className={styles.holdingTotalShares}>
            {holding.totalShares}
          </span>
        </div>
        <div className={styles.cell}>
          <span className={styles.holdingTotalCost}>{holding.costBasis}</span>
        </div>
      </div>
    </>
  );
}
